import React from 'react';

const Shipping = () => {
  return (
    <div>
      <h3>Shipping</h3>
    </div>
  );
};

export default Shipping;